import { render } from "./Models.vue?vue&type=template&id=7af157d2&scoped=true"
import script from "./Models.vue?vue&type=script&lang=js"
export * from "./Models.vue?vue&type=script&lang=js"

import "./Models.vue?vue&type=style&index=0&id=7af157d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7af157d2"]])

export default __exports__